import Row from '@components/Row';
import { ReactNode } from 'react';

import styles from './styles.module.scss';
import SubCategoryContext from './SubCategoryContext';

interface Props<T> {
    children?: ReactNode;
    value: T;
    setValue: (v: T) =>void;
    className?: string;
    isColorful?: boolean;
}

function Container<T>({
  children, value, setValue, className, isColorful,
}:Props<T>) {
  return (
        <SubCategoryContext value={{ value, setValue, isColorful }}>
            <Row fullWidth
                 spacing={10}
                 className={`${styles.container} ${className}`}>
                {children}
            </Row>
        </SubCategoryContext>
  );
}

export default Container;
